// 이용 안내 (정적) — 서류는 업체가 준비한다는 안내(차량번호만 신청, Jin 11/04) + 받는 항목 3개와 이유 + 진행 흐름.
// 받지 않는 정보는 적지 않는다(plan §10 E4). 문구는 전부 ARB malsoMode* 경유.
import React from 'react';
import { T } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import SimpleCard from '../../simple/parts/SimpleCard';

var page = { display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 720, margin: '0 auto' };
var title = { fontSize: 19, fontWeight: 800, letterSpacing: '-.35px', color: T.navy, marginBottom: 4 };
var lead = { fontSize: 13, color: T.body, lineHeight: 1.6, margin: 0 };
var item = { padding: '12px 14px', borderBottom: '1px solid ' + T.bdSoft };
var itemLast = { padding: '12px 14px' };
var t1 = { display: 'block', fontSize: 13, fontWeight: 700, color: T.ink };
var t2 = { display: 'block', fontSize: 11.5, color: T.muted, marginTop: 2, lineHeight: 1.5 };

function MalsoGuide() {
  var t = useT();
  var items = [
    [t('malsoModeGuideItemCar'), t('malsoModeGuideItemCarWhy')],
    [t('carCancelPickupSection'), t('malsoModeGuideItemPickupWhy')],
    [t('malsoModeGuideItemBuyer'), t('malsoModeGuideItemBuyerWhy')]
  ];
  return (<div style={page}>
    <h2 style={title}>{t('malsoModeGuideTitle')}</h2>
    <p style={lead}>{t('malsoModeDocsByCompanyHint')}</p>
    <SimpleCard>
      {items.map(function (it, i) {
        return (<div key={i} style={i === items.length - 1 ? itemLast : item}>
          <span style={t1}>{it[0]}</span>
          <span style={t2}>{it[1]}</span>
        </div>);
      })}
    </SimpleCard>
    <p style={lead}>{t('malsoModeGuideFlow')}</p>
  </div>);
}

export default MalsoGuide;
